import React from 'react';
import { connect } from 'react-redux';
import {
  selectUnselectDraft as selectUnselectDraftAction,
  applyToTemplates as applyToTemplatesAction,
  clickOk as clickOkAction,
} from '../../__storeFiles__/actions';
import {
  goBack as goBackAction,
} from 'react-router-redux';
import { RaisedButton, Dialog } from 'material-ui';
import SimpleTemplateList from '../../../template-list/simple-template-list';
import LoadingOverlay from '../../../../tc-ui/loading-overlay';
import OverwriteRules from '../overwrite-rules';
import injectCss from 'react-jss';
import styles from '../../styles';
import pluralize from 'pluralize';
import supplierWizardCompleteImage from '../../../../../../www/images/supplier-wizard-complete.svg';

const AssociateSecondaryToTemplatesWizard = ({
  goBack,
  selectUnselectDraft,
  allTemplatesDrafts,
  callingApi,
  successDialogOpen,
  classes,
  applyToTemplates,
  doc,
  clickOk,
  sameAsCorporatePolicyNotes,
}) => {
  const filtered = allTemplatesDrafts
    .filter(obj => {
      return !obj.isArchived && obj.policyNotesTemplateId !== doc._id;
    })
    .sort((objA, objB) => {
      if (objA.updatedAt > objB.updatedAt) return -1;
      return 1;
    });
  const totalSelected = allTemplatesDrafts.filter(obj => obj.checked).length;
  return (
    <div style={{ padding: '16px 0' }}>
      <div className="flex-tc-stretch">
        <div style={{ padding: '16px', width: '70%' }}>
          <div className={classes.applyStepperLabel}>
            Step 1: Select the templates that you’d like to apply the Corporate Policies & Notes to
          </div>
          <i>
            Note: At the present, you cannot apply Corporate Policies & Notes directly to completed templates. We hope to provide you with this ability in the near future.
          </i>
          <br/>
          <br/>
          <SimpleTemplateList templates={filtered} selectOrUnselect={selectUnselectDraft} />
        </div>
        <OverwriteRules
          classes={classes}
        />
      </div>
      <div className={`${classes.bottomBar} flex-tc-sb ${totalSelected ? 'is-active' : ''}`}>
        {totalSelected} {pluralize('templates', totalSelected)} selected. &nbsp;
        <RaisedButton
          label="Apply"
          primary
          disabled={!totalSelected || callingApi || !sameAsCorporatePolicyNotes.length}
          onTouchTap={applyToTemplates}
        />
      </div>
      <Dialog
        open={successDialogOpen}
        contentStyle={{ textAlign: 'center' }}
      >
        <img
          alt=""
          src={supplierWizardCompleteImage}
          style={{ width: '25%', display: 'block', margin: 'auto' }}
        />
        <h4>{doc.templateName} has been applied to selected templates successfully.</h4>
        <div style={{ width: '100%' }} className="flex-tc-sb">
          <RaisedButton
            primary
            label="View My Templates"
            onTouchTap={goBack}
          />
          <RaisedButton secondary label="View All Associated Templates" onTouchTap={clickOk} />
        </div>
      </Dialog>
      <LoadingOverlay loading={callingApi} />
    </div>
  );
};

const mapStateToProps = ({
  contracting: {
    masterTemplate: { applyMasterToTemplatesReducer, docs },
  },
}) => {
  return {
    ...applyMasterToTemplatesReducer,
    doc: docs[docs.currentId],
  };
};

export default connect(
  mapStateToProps,
  {
    goBack: goBackAction,
    selectUnselectDraft: selectUnselectDraftAction,
    applyToTemplates: applyToTemplatesAction,
    clickOk: clickOkAction,
  },
)(injectCss(styles)(AssociateSecondaryToTemplatesWizard));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/apply-master-wizards/apply-one-master-to-multiple/wizard.jsx